export default __webpack_public_path__ + "static/media/hotel.d73daf35.svg";